"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.Datepicker = void 0;
var Datepicker_1 = require("./Datepicker");
Object.defineProperty(exports, "Datepicker", { enumerable: true, get: function () { return Datepicker_1.Datepicker; } });
//# sourceMappingURL=index.js.map